import React from 'react';
import { getPauseBadge, PauseBadgeKind, PauseLike } from '@/features/membershipPause/status';

type Props = {
    pass: { status?: unknown; isDeleted?: unknown; isCanceled?: unknown; pause?: PauseLike } | null | undefined;
    /** onColor: 색 배경(수강권 카드 머리) 위, default: 흰 배경 위 */
    variant?: 'default' | 'onColor';
    className?: string;
};

const DEFAULT_TONE: Record<PauseBadgeKind, string> = {
    scheduled: 'bg-[#F1F5F9] text-[#475569] border-[#E2E8F0]',
    active: 'bg-[#FFF7ED] text-[#C2410C] border-[#FED7AA]',
    resuming: 'bg-[#EFF6FF] text-[#1D4ED8] border-[#BFDBFE]',
};

/**
 * 정지 배지 — 「정지 예정」/「정지 중 · 기간 또는 N일째」/「해제 처리 중」.
 * 사용 중인 수강권에 열린 정지가 있을 때만 그린다. 정지 기능이 없는 서버(롤백 빌드 포함)에서도
 * 남아 있는 정지는 그대로 보여준다(사용자 결정 2026-10-21) — 메뉴·확인 창만 숨긴다.
 */
const MembershipPauseBadge = ({ pass, variant = 'default', className = '' }: Props) => {
    const badge = getPauseBadge(pass);
    if (!badge) return null;
    const tone =
        variant === 'onColor'
            ? 'bg-[rgba(255,255,255,0.92)] text-[#9A3412] border-[rgba(255,255,255,0.92)]'
            : DEFAULT_TONE[badge.kind];
    return (
        <span
            className={`inline-flex max-w-[260px] items-center truncate whitespace-nowrap rounded-[4px] border px-[8px] py-[3px] text-[11px] font-bold leading-[1.4] ${tone} ${className}`}
            title={badge.label}
        >
            {badge.label}
        </span>
    );
};

export default MembershipPauseBadge;
